import Scroller from 'vux/src/components/scroller/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'sellOrders',
components: {
Scroller,
Datetime
},
data () {
return {
list: [],
page: 1,
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
noData: false,
startTime: '',
endTime: '',
}
},
methods: {
fetchData(cb) {
this.$request.post('/design/orderList',{
page: this.page,
rows: 10,
obj: {
startTime: this.startTime,
endTime: this.endTime,
searchContent: '',
},
},).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
refresh() {
this.page = 1
this.fetchData(data => {
this.list = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
console.log('下拉刷新成功')
})
this.page += 1
},
loadMore() {
this.fetchData(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
console.log(this.list)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
changeStartTime (value) {
console.log(value)
this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.loadMore()
},
changeEndTime (value) {
console.log(value)
this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.loadMore()
},
goDetail (item, index) {
this.$router.push({
path: '/commodity',
query: {
id: item.spuId
}
})
},
clearStartTime () {
this.startTime = ''
},
clearEndTime () {
this.endTime = ''
},
},
computed: {

},
created () {

},
mounted() {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.loadMore()
},
}



// WEBPACK FOOTER //
// ./src/views/myStore/sellOrders/script.js